export default __webpack_public_path__ + "static/media/No55Open.49c01e58.jpg";